import { apiSlice } from '@/api'

export const mainApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMenu: builder.query({
      query: () => ({
        url: 'api/v2/permissions/menu',
        method: 'GET'
      })
    })
  })
})

export const { useGetMenuQuery } = mainApiSlice
